module.exports = __webpack_public_path__ + "img/footerc.485b248d.jpg";